import React from 'react'
import { Clock, Users, Gamepad2, Calculator } from 'lucide-react'
import type { HourStatsAnalysisProps } from '@/features/enrollment'

export default function HourStatsAnalysis({ hourStats }: HourStatsAnalysisProps) {
  return (
    <div className="border border-blue-200 rounded-lg p-4 lg:p-6 bg-blue-50">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
          <Calculator className="w-5 h-5 text-blue-600" />
        </div>
        <div>
          <h4 className="font-semibold text-blue-900">Gamertag Hour Analysis</h4>
          <p className="text-sm text-blue-600">Your gaming hours eligibility breakdown</p>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Total Hours */}
        <div className="bg-white rounded-lg p-4 border border-blue-200">
          <div className="flex items-center space-x-2 mb-2">
            <Clock className="w-4 h-4 text-blue-500" />
            <span className="text-sm font-medium text-blue-700">Total Hours</span>
          </div>
          <div className="text-2xl font-bold text-blue-900">{hourStats.totalHours.toLocaleString()}</div>
          <p className="text-xs text-blue-600 mt-1">Total gaming hours from gamertag</p>
        </div>

        {/* Eligible Gamers */}
        <div className="bg-white rounded-lg p-4 border border-green-200">
          <div className="flex items-center space-x-2 mb-2">
            <Users className="w-4 h-4 text-green-500" />
            <span className="text-sm font-medium text-green-700">Eligible Gamers</span>
          </div>
          <div className="text-2xl font-bold text-green-900">{hourStats.eligibleGamers}</div>
          <p className="text-xs text-green-600 mt-1">Total Hours ÷ 1,100</p>
        </div>

        {/* Remaining Gamers */}
        <div className="bg-white rounded-lg p-4 border border-orange-200">
          <div className="flex items-center space-x-2 mb-2">
            <Gamepad2 className="w-4 h-4 text-orange-500" />
            <span className="text-sm font-medium text-orange-700">Remaining Gamers</span>
          </div>
          <div className="text-2xl font-bold text-orange-900">{hourStats.remainingGamers}</div>
          <p className="text-xs text-orange-600 mt-1">Can still enroll with this gamertag</p>
        </div>
      </div>

      {/* Hour Calculation Explanation */}
      <div className="mt-4 p-3 bg-blue-100 rounded-lg">
        <p className="text-sm text-blue-800">
          <strong>How it works:</strong> Each person needs 1,100 hours to qualify. 
          Your {hourStats.totalHours.toLocaleString()} hours can support {hourStats.eligibleGamers} eligible gamers. 
          {hourStats.remainingGamers > 0 ? (
            <span className="font-semibold"> You can enroll {hourStats.remainingGamers} more {hourStats.remainingGamers === 1 ? 'person' : 'people'} with this gamertag.</span>
          ) : (
            <span className="font-semibold"> No more enrollments possible with this gamertag.</span>
          )}
        </p>
      </div>
    </div>
  )
}
